import { addUserLoginLog } from '@/api/UserLoginLog'

const storageKey = 'user_login_log_status'

function getToday() {
  const now = new Date()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const date = String(now.getDate()).padStart(2, '0')
  return `${now.getFullYear()}-${month}-${date}`
}

function getStatus() {
  try {
    return JSON.parse(localStorage.getItem(storageKey) || '{}')
  } catch (error) {
    return {}
  }
}

function saveTodayStatus(today) {
  localStorage.setItem(storageKey, JSON.stringify({ [today]: true }))
}

function recordTodayLogin() {
  const today = getToday()
  const status = getStatus()

  // 只保留今天的状态，避免长期累积历史日期。
  if (Object.keys(status).some(key => key !== today)) {
    localStorage.removeItem(storageKey)
  }

  return addUserLoginLog()
    .then(() => {
      saveTodayStatus(today)
    })
    .catch(() => {
      // 登录记录失败不影响当前页面的正常使用，下一次定时任务会重试。
    })
}

export function startUserLoginLog() {
  let timer = null

  const run = () => {
    if (localStorage.getItem('Token') && window.location.pathname !== '/') {
      recordTodayLogin()
    }
  }

  run()
  timer = window.setInterval(run, 60 * 1000)

  return () => {
    if (timer) {
      window.clearInterval(timer)
    }
  }
}
